// extracted by mini-css-extract-plugin
export default {"app":"app_app__9SwR3"};